import { render, staticRenderFns } from "./BottomBarNavigationItem.vue?vue&type=template&id=ce523acc"
import script from "./BottomBarNavigationItem.vue?vue&type=script&lang=js"
export * from "./BottomBarNavigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports